exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/confirmation-dialog/confirmation-dialog.component.scss
// module id = ../../../../../src/app/shared/components/confirmation-dialog/confirmation-dialog.component.scss
// module chunks = main